<div class="parent">
  <div class="spinner-container">
    <ion-spinner name="bubbles" color="primary"></ion-spinner>
  </div>
</div>